export default "__VITE_ASSET__D5Z8EN5m__"